module.exports = __webpack_public_path__ + "img/logo_tiktok.33113aca.png";